<div class="tool">
    <div class="time" >
        <span *ngIf="submitAt!== '' ">{{submitAt}}</span>
    </div>
    <div class="tools">
        <div class="comment" (click)="goComment()">
            <div class="comment_icon" [ngClass]="commentCount? 'active':'' " ></div>
            <span *ngIf="!commentCount">评论</span>
            <span *ngIf="commentCount"  >{{commentCount}}</span>
        </div>
        <div class="favour" (click)="favour()" >
            <div class="favour_icon favour_icon-{{relationId}}" [ngClass] = "userClick? 'active' : '' "  ></div>
            <span class="appreciated appreciated-{{relationId}}"  *ngIf="userClick || showCount" [ngClass] = "userClick || showCount? 'active' : '' "  >{{appreciateCount}}</span>
            <span class="appreciate appreciate-{{relationId}}" *ngIf="!userClick && !showCount" >点赞</span>
        </div>
    </div>
</div>



// WEBPACK FOOTER //
// ./src/component/tool/component.tool.html